import cssVariable from './cssVariable';
import hashScroll from './hashScroll';
import imageLoaded from './imageLoaded';
import inview from './inview';
import toggleMenu from './toggleMenu';
import accordion from './accordion';
import navigationClose from './navigationClose';
import fontChange from './fontSize';
import tab from './tab';
import mainVisualSlider from './mainVisualSlider';
import slider from './slider';
import blankLabel from './blankLabel';
import initCurrent from './current.js';
import SelectStyle from './select';
import matchingFloatingCta from './matchingFloatingCta';

document.addEventListener('DOMContentLoaded', () => {
  cssVariable();
  hashScroll();
  imageLoaded();
  inview();
  toggleMenu();
  accordion();
  // navigationCloseはtoggleMenuおよびaccordionの後に実行する必要がある
  navigationClose();
  fontChange();
  tab();
  mainVisualSlider();
  slider();
  blankLabel();
  initCurrent();
  new SelectStyle('.ModuleSelect');
  matchingFloatingCta();
});
